module.exports = __webpack_public_path__ + "img/20210818.80461d40.gif";